/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiSsoProviderCompanyMappingFromJSON, StreemApiSsoProviderCompanyMappingToJSON, } from './';
export function StreemApiUpdateSsoProviderCompanyMappingResponseFromJSON(json) {
    return StreemApiUpdateSsoProviderCompanyMappingResponseFromJSONTyped(json, false);
}
export function StreemApiUpdateSsoProviderCompanyMappingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ssoProviderCompanyMapping': !exists(json, 'sso_provider_company_mapping') ? undefined : StreemApiSsoProviderCompanyMappingFromJSON(json['sso_provider_company_mapping']),
    };
}
export function StreemApiUpdateSsoProviderCompanyMappingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sso_provider_company_mapping': StreemApiSsoProviderCompanyMappingToJSON(value.ssoProviderCompanyMapping),
    };
}
//# sourceMappingURL=StreemApiUpdateSsoProviderCompanyMappingResponse.js.map